import {
    ApplicationRoleCode,
    CorporationUserRole,
    UserCorporationChild,
} from '@kcftech/prometheus-client';
import { useUser } from 'contexts/UserContext';
import { NotFound } from 'pages/NotFound';
import { Redirect } from 'react-router-dom';
import {
    getCorporationLandingPageRoute,
    getHardwareRoute,
    getLocationLandingPageRoute,
} from 'utils/RouteHelper';

const isNonNone = (corp: UserCorporationChild) =>
    corp.CorporationUserRole !== CorporationUserRole.None;

export function LandingPage() {
    const userContext = useUser();
    if (!userContext.token) {
        return <Redirect to="/login" />;
    }
    // This should never happen, we do not show anything in the UserContext if there is not a
    // userContext.user, so we won't even get here if there isn't a user (but eslint complains
    // about possibly undefined so here we are)
    if (!userContext.user) {
        // for now we redirect to default. At some point this need to be included in
        // the process after a user is authenticated and not go to login
        return <Redirect to="/" />;
    }

    const corporations = userContext.user.Corporations;
    const locations = userContext.user.Locations;

    switch (userContext.user.ApplicationRole) {
        case ApplicationRoleCode.Sales:
        case ApplicationRoleCode.Sentry:
        case ApplicationRoleCode.SystemAdmin:
            return <Redirect to="/internal" />;
        case ApplicationRoleCode.User: {
            if (corporations.length === 0) {
                return <Redirect to="/internal" />;
            }

            // Default to internal if there are multiple possible default
            // destinations
            // ToDo: we should remove `.filter(isNonNone)`
            if (locations.length > 1 || corporations.filter(isNonNone).length > 1) {
                return <Redirect to="/internal" />;
            }

            if (locations.length === 1) {
                const soleLocation = locations[0];
                return soleLocation.IsPremium ? (
                    <Redirect to={getLocationLandingPageRoute(soleLocation.LocationId)} />
                ) : (
                    <Redirect to={getHardwareRoute(undefined, soleLocation.LocationId)} />
                );
            }

            const soleNonNoneCorporation = corporations.find(isNonNone);

            if (soleNonNoneCorporation === undefined) {
                return <Redirect to="/internal" />;
            }

            return soleNonNoneCorporation.IsPremium ? (
                <Redirect
                    to={getCorporationLandingPageRoute(
                        soleNonNoneCorporation.CorporationId,
                    )}
                />
            ) : (
                <Redirect to={getHardwareRoute(soleNonNoneCorporation.CorporationId)} />
            );
        }

        default:
            return <NotFound />;
    }
}
